// FIXME: Fix this the next time the file is edited.
// @ts-expect-error TS(6133): 'groupBy' is declared but its value is never read.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { groupBy, keyBy } from "lodash";

import {
  CRUDAction,
  IEntityCreateSuccess,
  IEntityDeleteSuccess,
  IEntityFetchCollectionSuccess,
  RequestAction,
} from "store/entities/actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";

import { CUSTOM_FIELD, CustomFieldAction } from "./actions";
import { ICustomField } from "./interfaces";

const initialState = {};

export type ICustomFieldsState = IEntityCollectionState<ICustomField>;

export const customFieldsReducer = (
  state: IEntityCollectionState<ICustomField> = initialState,
  action: CustomFieldAction
): ICustomFieldsState => {
  switch (action.type) {
    case CUSTOM_FIELD[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'CustomF... Remove this comment to see the full error message
      const { values } = action.payload as IEntityFetchCollectionSuccess<ICustomField>;
      return keyBy(values, v => v.id);
    }
    case CUSTOM_FIELD[CRUDAction.CREATE][RequestAction.SUCCESS]:
    case CUSTOM_FIELD[CRUDAction.UPDATE][RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'CustomF... Remove this comment to see the full error message
      const { value } = action.payload as IEntityCreateSuccess<ICustomField>;
      return {
        ...state,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        [value.id]: {
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          ...state[value.id],
          ...value,
        },
      };
    }
    case CUSTOM_FIELD[CRUDAction.DELETE][RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'CustomF... Remove this comment to see the full error message
      const { id } = action.payload as IEntityDeleteSuccess;
      const newState = { ...state };
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      delete newState[id];
      return newState;
    }

    default:
      return state;
  }
};
